import axios, { AxiosInstance } from 'axios'

export const mobileAxiosInstance: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_MOBILE_URL,
  timeout: 10000,
})
